import { render } from "./UrlModal.vue?vue&type=template&id=19670d52&scoped=true"
import script from "./UrlModal.vue?vue&type=script&lang=js"
export * from "./UrlModal.vue?vue&type=script&lang=js"

import "./UrlModal.vue?vue&type=style&index=0&id=19670d52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19670d52"]])

export default __exports__